class Blob {
	constructor(ref) {

		this.width = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;

		this.height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;		
		this.render(ref);
	}

	render(ref) {

		this.speed = .3;
		this.totalNodes = 10;
		const radius = 1000;
		const amplitudeFactor = 1.2;
		const debug = false; //Draw anchors and handles
 
		const boxWidth = this.width;
		const boxHeight = this.height;
		const xmlns = 'http://www.w3.org/2000/svg';  
		const svg = document.createElementNS(xmlns, 'svg');
		svg.setAttributeNS(null, 'viewBox', `0 0 ${boxWidth} ${boxHeight}`);
		svg.setAttributeNS(null, 'width', boxWidth);
		svg.setAttributeNS(null, 'height', boxHeight);
		svg.setAttributeNS(null, 'style', `width: 100%; height: 100%; box-sizing: border-box`);


		ref.appendChild(svg);

		const centerX = boxWidth / 2;
		const centerY = boxHeight / 2;
		const offsetX = centerX - radius * 1.55;
		const offsetY = centerY - radius * 0.4;
		this.amplitude = radius / Math.max(Math.min(this.totalNodes, 7), 4) * amplitudeFactor;
		const debugOpacity = debug ? '44' : '00';

		const defs = document.createElementNS(xmlns, 'defs');
		svg.appendChild(defs);
		defs.appendChild(this.createGradient(xmlns, 'gradient1', '#50F6C2', '#80FFF2'));
		defs.appendChild(this.createGradient(xmlns, 'gradient2', '#EE39EF', '#EE39EF'));
		defs.appendChild(this.createGradient(xmlns, 'gradient3', '#FF2CEFee', '#FF74FFee'));

		const g = document.createElementNS(xmlns, 'g');
			g.setAttributeNS(null, 'opacity', '0.9');
			g.setAttributeNS(null, 'style', `mix-blend-mode: multiply;`);
		
		svg.appendChild(g);

		this.path = document.createElementNS(xmlns, 'path');
		// this.path.setAttributeNS(null, 'fill', `url(${window.location.href}#gradient2)`);
		this.path.setAttributeNS(null, 'fill', `#EE39EF`);

		g.appendChild(this.path);

		this.nodes = (
			this && this.totalNodes * radius === this.hash && this.nodes
		) || this.createNodes(radius, offsetX, offsetY, this.amplitude);
		
		this.controlPoints = (
			this && this.totalNodes * radius === this.hash && this.controlPoints
		) || this.createControlPoints(this.nodes, radius, offsetX, offsetY);
		this.appendNodes(this.nodes, this.controlPoints, g, xmlns, debugOpacity);
		this.appendControlPoints(this.nodes, this.controlPoints, g, xmlns, debugOpacity);
		this.drawBlobPath(this.nodes, this.controlPoints, this.path);

		svg.nodes = this.nodes;
		svg.controlPoints = this.controlPoints;
		svg.hash = this.totalNodes * radius;

		setInterval(() => this.draw(), 10);
	}

	draw() {
			this.update(this.nodes, this.controlPoints, this.amplitude);
			this.drawBlobPath(this.nodes, this.controlPoints, this.path);
	}

	ease (t) {
		return -(Math.cos(Math.PI / 2 * t * 5) - 2) / 256 * this.speed;
	}	

	rotate(cx, cy, x, y, radians) {
		const cos = Math.cos(radians),
			sin = Math.sin(radians),
			nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
			ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
		return [nx, ny];
	}

	createNodes (radius, offsetX, offsetY) {
		let num = this.totalNodes,
				nodes = [], 
				width = (radius * 2),
				height = (radius * 2),
				angle,
				x,
				y;
		for (let i = 0; i < num; i++) {
			angle = (i / (num / 2)) * Math.PI; // Angle at which the node will be placed
			x = (radius * Math.cos(angle)) + (width / 2);
			y = (radius * Math.sin(angle)) + (width / 2);
			nodes.push({
				id: i,
				x: x + offsetX,
				y: y + offsetY,
				prevX: x + offsetX,
				prevY: y + offsetY,
				nextX: x + offsetX,
				nextY: y + offsetY,
				baseX: x + offsetX,
				baseY: y + offsetY,
				angle,
				debug: {}
			});
		}
		return nodes;
	}

	appendNodes(nodes, controlPoints, svg, xmlns, debugOpacity) {
		nodes.forEach((n, i) => {
			const line = document.createElementNS(xmlns, 'path');
			line.setAttributeNS(null, 'stroke', `#000000${debugOpacity}`);
			line.setAttributeNS(null, 'stroke-width', '1');
			line.setAttributeNS(null, 'd', `
				M${controlPoints[n.id].c1x} ${controlPoints[n.id].c1y}
				L${controlPoints[n.id].c2x} ${controlPoints[n.id].c2y}
			`);
			svg.appendChild(line);
			nodes[i].debug.cpLine = line;

			const circle = document.createElementNS(xmlns, 'circle');
			circle.setAttributeNS(null, 'fill', `#000000${debugOpacity}`);
			circle.setAttributeNS(null, 'cx', n.x);
			circle.setAttributeNS(null, 'cy', n.y);
			circle.setAttributeNS(null, 'r', 3);
			svg.appendChild(circle);
			nodes[i].debug.node = circle;
		});
	}	

	createControlPoints(nodes, radius, offsetX, offsetY) {
		// https://stackoverflow.com/questions/1734745/how-to-create-circle-with-b%C3%A9zier-curves
		const idealControlPointDistance = (4 / 3) * Math.tan(Math.PI / (2 * this.totalNodes)) * radius;

		const cp0 = {
			c1x: nodes[0].x,
			c1y: nodes[0].y - idealControlPointDistance,
			c2x: nodes[0].x,
			c2y: nodes[0].y + idealControlPointDistance
		};

		return nodes.map(
			(n, i) => {
				if (i === 0) {
					return cp0;
				} else {
					const angle = -n.angle;
					const rotatedC1 = this.rotate(radius + offsetX, radius + offsetY, cp0.c1x, cp0.c1y, angle);
					const rotatedC2 = this.rotate(radius + offsetX, radius + offsetY, cp0.c2x, cp0.c2y, angle);
					return {
						c1x: rotatedC1[0],
						c1y: rotatedC1[1],
						c2x: rotatedC2[0],
						c2y: rotatedC2[1]
					};
				}
			}
		);
	}

	appendControlPoints(nodes, controlPoints, svg, xmlns, debugOpacity) {
		controlPoints.forEach((n, i) => {
			const circle = document.createElementNS(xmlns, 'circle');
			circle.setAttributeNS(null, 'fill', `#000000${debugOpacity}`);
			circle.setAttributeNS(null, 'cx', n.c1x);
			circle.setAttributeNS(null, 'cy', n.c1y);
			circle.setAttributeNS(null, 'r', 2);
			svg.appendChild(circle);
			nodes[i].debug.cp1 = circle;
			
			const circle2 = document.createElementNS(xmlns, 'circle');
			circle2.setAttributeNS(null, 'fill', `#000000${debugOpacity}`);
			circle2.setAttributeNS(null, 'cx', n.c2x);
			circle2.setAttributeNS(null, 'cy', n.c2y);
			circle2.setAttributeNS(null, 'r', 2);
			svg.appendChild(circle2);
			nodes[i].debug.cp2 = circle2;
		});
	}

	update(nodes, controlPoints, amplitude) {
		nodes.forEach((n, i) => {
			if (Math.abs(nodes[i].nextX - nodes[i].x) < 10) {
				const shiftX = (~~(Math.random() * 5) - 2) * Math.random() * amplitude / 2; 
				nodes[i].prevX = nodes[i].x;
				nodes[i].nextX = nodes[i].baseX + shiftX;
			}
			if (Math.abs(nodes[i].nextY - nodes[i].y) < 10) {
				const shiftY = (~~(Math.random() * 5) - 2) * Math.random() * amplitude / 2; 
				nodes[i].prevY = nodes[i].y;
				nodes[i].nextY = nodes[i].baseY + shiftY;
			}
			const distanceX = nodes[i].nextX - nodes[i].prevX;
			const distanceY = nodes[i].nextY - nodes[i].prevY;
			const remainingDistanceX = nodes[i].nextX - nodes[i].x;
			const remainingDistanceY = nodes[i].nextY - nodes[i].y;
			let tX = 1 - remainingDistanceX / distanceX;
			let tY = 1 - remainingDistanceY / distanceY;

			const shiftX = this.ease(tX > 0 ? tX : 0.2) * distanceX;
			const shiftY = this.ease(tY > 0 ? tY : 0.2) * distanceY;

			nodes[i].x += shiftX;
			nodes[i].y += shiftY;
			controlPoints[i].c1x += shiftX;
			controlPoints[i].c1y += shiftY;
			controlPoints[i].c2x += shiftX;
			controlPoints[i].c2y += shiftY;

			n.debug.cpLine.setAttributeNS(null, 'd', `
				M${controlPoints[i].c1x} ${controlPoints[i].c1y}
				L${controlPoints[i].c2x} ${controlPoints[i].c2y}
			`);
			n.debug.node.setAttributeNS(null, 'cx', n.x);
			n.debug.node.setAttributeNS(null, 'cy', n.y);

			n.debug.cp1.setAttributeNS(null, 'cx', controlPoints[i].c1x);
			n.debug.cp1.setAttributeNS(null, 'cy', controlPoints[i].c1y);
			n.debug.cp2.setAttributeNS(null, 'cx', controlPoints[i].c2x);
			n.debug.cp2.setAttributeNS(null, 'cy', controlPoints[i].c2y);
		});
	}	

	drawBlobPath(nodes, controlPoints, path) {
		path.setAttributeNS(null, 'd', `
			M${nodes[nodes.length - 1].x} ${nodes[nodes.length - 1].y}
			${nodes.map((n, i) => `
			C ${i === 0
				? controlPoints[controlPoints.length - 1].c2x
				: controlPoints[i - 1].c2x
			} ${i === 0
				? controlPoints[controlPoints.length - 1].c2y
				: controlPoints[i - 1].c2y
			}, ${controlPoints[i].c1x} ${controlPoints[i].c1y}, ${n.x} ${n.y}
			`).join('')}
					Z
				`);
	}

	createGradient(xmlns, id, color1, color2) {
		const radialGradient = document.createElementNS(xmlns, 'radialGradient');
		radialGradient.setAttributeNS(null, 'id', id);
		const stop1 = document.createElementNS(xmlns, 'stop');
		stop1.setAttributeNS(null, 'offset', '0%');
		stop1.setAttributeNS(null, 'stop-color', color1);
		radialGradient.appendChild(stop1);
		const stop2 = document.createElementNS(xmlns, 'stop');
		stop2.setAttributeNS(null, 'offset', '100%');
		stop2.setAttributeNS(null, 'stop-color', color2);
		radialGradient.appendChild(stop2);
		return radialGradient;
	}
}

export default Blob;